import React from 'react'
import ReactDOM from 'react-dom/client'
import Application from './Application'
import './styles/reset.css'
import './styles/index.css'

ReactDOM.createRoot(document.getElementById('root')).render(<Application />,)
